module.exports = __webpack_public_path__ + "static/media/pb_logo_icon.f0b86b0c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pb_logo_icon.svg
// module id = 66
// module chunks = 0